export const areDatesSameDay = (dateA, dateB) => {
  return (
    dateA.getFullYear() === dateB.getFullYear()
      && dateA.getMonth() === dateB.getMonth()
      && dateA.getDate() === dateB.getDate()
  );
};